import * as React from 'react'
import { Button } from '../button'
import { calendar } from '../icon'
import EventType from '../../models/eventType'
import './CalendarButton.scss'

type Props = {
    eventId: string
    companyId: string
    eventType?: EventType
}

class CalendarButton extends React.Component<Props> {
    componentDidMount() {
        const { eventId, companyId } = this.props

        const eventable = new (window as any).Eventable({
            eventId,
            key: companyId,
            target: 'customCalendarButton',
            hideBranding: false,
        })

        eventable.init()
    }

    render() {
        const { eventId, companyId, children, eventType } = this.props
        const link = `https://add.eventable.com/events/${companyId}/${eventId}/`

        return (
            <>
                <Button
                    className={`${eventType && `calendarButton--${eventType}`}`}
                    buttonType='primary'
                    id='customCalendarButton'
                    buttonStyle='square'
                    size='large'
                    redirectUrl={link}
                    icon={calendar}
                >
                    {children}
                </Button>
                <a
                    href={link}
                    data-event={eventId}
                    className='eventable-link'
                    target='_blank'
                    data-key={companyId}
                    data-target='customCalendarButton'
                    style={{ display: 'none' }}
                >
                    {children}
                </a>
            </>
        )
    }
}

export { CalendarButton }
